import { useMemo } from 'react'
import { useReportPageContext } from '../context/useReportPageContext'
import { ReportPanelProvider } from '../context/useReportPanelContext'
import ReportPageSection from './ReportPageSection'
import { Skeleton, Typography, Container } from '@mui/material'
import NoReportsIcon from './NoReportsIcon'
import styles from './ReportPage.module.scss'

const ReportPageGraphsContainer = () => {
    const { selectedTemplate, uuid, selectedTickers, peerAnalysisTemplate, tab } = useReportPageContext()

    const section = useMemo(() => (
        tab && <ReportPanelProvider key={tab} ticker={tab} template={selectedTemplate} uuid={uuid} peerAnalysisTemplate={peerAnalysisTemplate}>
            <ReportPageSection key={tab} ticker={tab} selectedTemplate={selectedTemplate} peerAnalysisTemplate={peerAnalysisTemplate}/>
        </ReportPanelProvider>
    ),[selectedTemplate, tab, uuid, peerAnalysisTemplate])

    const reports = useMemo(() => (
        selectedTickers?.length
            ? section
            : <NoReports /> 
    ),[section, selectedTickers])

    return ( 
        <div className={styles['container']}>
            {(uuid && selectedTickers ) ? reports : <Container maxWidth='xl'><Skeleton width='100%' height='400px'/></Container>}
        </div>
    )
}

const NoReports = () => {
    return (
        <div className={styles['no-reports-msg']}>
            <NoReportsIcon/>
            <div>
                <Typography variant='h2'>No report data</Typography>
                <Typography variant='h3' color='textSecondary'>{"Start by adding companies and data \n sets templates to fill this report"}</Typography>
            </div>
        </div>
    )
}

export default ReportPageGraphsContainer
